import { MARKET_ROYALTY_ADDRESS } from '@/utils/constants'
import { OFFERS_PREVIEW_BUILD } from './offer-env'

/**
 * Ordinals Wallet's co-signer x-only public key, pinned in the client. Every
 * offer escrow's sale leaf is `<buyer> CHECKSIG <cosigner> CHECKSIGADD 2
 * NUMEQUAL`, so an API that published any other key could spend a funded
 * escrow with a key of its own choosing. The client refuses to fund an offer
 * whose intent names a different key. Production and the preview API share
 * this key; a preview or local development build (OFFERS_PREVIEW_BUILD) may
 * override it with NEXT_PUBLIC_OFFER_COSIGNER_PUBLIC_KEY (64 hex characters)
 * for another network. Every other build ignores the override.
 */
export const PRODUCTION_OFFER_COSIGNER_PUBLIC_KEY =
	'1d08b7c71f6f1e97a0a4cf005db7a977c85e34652a0c9365842aee25997c7dee'

const configured = OFFERS_PREVIEW_BUILD ? process.env.NEXT_PUBLIC_OFFER_COSIGNER_PUBLIC_KEY || '' : ''

export const OFFER_COSIGNER_PUBLIC_KEY = (
	/^[0-9a-f]{64}$/i.test(configured) ? configured : PRODUCTION_OFFER_COSIGNER_PUBLIC_KEY
).toLowerCase()

/**
 * The market fee output every offer settlement pays. The intent the buyer
 * signs names it (field 21), and the client only funds an intent that names
 * this address, so the API cannot redirect the fee output of a settlement
 * the buyer pre-signed.
 */
export const OFFER_MARKET_FEE_ADDRESS: string = MARKET_ROYALTY_ADDRESS

/**
 * Postage above this on the seller's item output asks the seller to tick an
 * explicit acknowledgement: the whole output, not just the inscription,
 * travels to the buyer when an offer is accepted or filled.
 */
export const OFFER_POSTAGE_ACK_SATS = 10_000

/**
 * An offer at least this far under the floor price (percent) is a sale a
 * seller rarely means. Accepting one shows a red warning, needs a ticked
 * acknowledgement naming the discount, and the accept button names it too.
 */
export const OFFER_DEEP_DISCOUNT_PERCENT = 30
